import { render, staticRenderFns } from "./AlertComponent.vue?vue&type=template&id=0335c546&scoped=true&"
import script from "./AlertComponent.vue?vue&type=script&lang=js&"
export * from "./AlertComponent.vue?vue&type=script&lang=js&"
import style0 from "./AlertComponent.vue?vue&type=style&index=0&id=0335c546&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0335c546",
  null
  
)

component.options.__file = "AlertComponent.vue"
export default component.exports